module.exports = __webpack_public_path__ + "img/464071.8c5970f4.jpg";